import { Box } from "@mantine/core";
import { RpiTable } from "../../rpi-core/table/RpiTable";
import { useAuthUser } from "../../hooks/useAuthUser";
import React from "react";
import { GraphQL, GraphQLPagedQueryData } from "@rpi/openapi-api";
import { SearchInputs, SearchSort } from "../../utils/graphql.util";
import { useNavigateRoute } from "../../hooks/useNavigateRoute";
import { createRpiTableRowMenu } from "../../rpi-core/table/RpiTableRowMenu";
import { optArray } from "../../utils/misc.util";
import { customerProductColumns } from "../../configuration/columns/customerProduct.column";
import { featureFlags } from "../../featureFlags";

export interface CustomerProductsTableV1Props {
  customerProducts?: GraphQLPagedQueryData<GraphQL.CustomerProductsQuery>[];
  isLoading: boolean;
  error: any;
  searchInputs: SearchInputs<GraphQL.CustomerProductsQueryVariables> | undefined;
  searchGeneral?: string | null;
  setSortInput: (sort: SearchSort<GraphQL.CustomerProductsQueryVariables>) => void;
  pagination: {
    perPage: number;
  };
  setProductId: (id: number) => void;
  setIsPriceCalculatorOpen: () => void;
}

export const CustomerProductsTableV1: React.FC<CustomerProductsTableV1Props> = ({
  customerProducts,
  isLoading,
  error,
  searchInputs,
  searchGeneral,
  setSortInput,
  pagination,
  setProductId,
  setIsPriceCalculatorOpen,
}) => {
  const user = useAuthUser();
  const navigateRoute = useNavigateRoute();

  const canModify = user.is.CUSTOMER_ADMIN || user.is.SUPER_ADMIN;

  return (
    <Box
      sx={{
        "& .mantine-Menu-dropdown": {
          width: "125px !important",
        },
      }}
    >
      <RpiTable
        emptyMessage={searchInputs?.length || searchGeneral ? "No products found." : "Your products will appear here."}
        isLoading={isLoading}
        error={error}
        perPage={pagination.perPage}
        data={customerProducts}
        columns={customerProductColumns}
        additionalColumns={[
          createRpiTableRowMenu<Pick<GraphQLPagedQueryData<GraphQL.CustomerProductsQuery>, "id" | "openapiProductId">>(
            ({ row }) => [
              {
                label: "View",
                onClick: () => navigateRoute(["customer-product", { id: row.id }]),
              },
              ...optArray(featureFlags.newProductCreate, [
                {
                  label: "Price Calculator",
                  onClick: () => {
                    setProductId(row.id);
                    setIsPriceCalculatorOpen();
                  },
                },
              ]),
              ...optArray(canModify, [
                {
                  label: "Edit",
                  onClick: () => navigateRoute(["customer-product:edit", { id: row.id }]),
                },
              ]),
            ]
          ),
        ]}
        withSortBy={{
          defaultValue: {
            by: GraphQL.CustomerProductSearchField.Id,
            sortDirection: GraphQL.SortDirection.Desc,
          },
          onChange: setSortInput,
        }}
      />
    </Box>
  );
};
